var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.qrCodeComponentHandler)?_c(_vm.qrCodeComponentHandler,{tag:"component",staticClass:"qr-generator__img",attrs:{"text":_vm.link}}):_vm._e(),(_vm.secretCode)?_c('gf-custom-clipboard',{staticClass:"mt-3",attrs:{"prepended-text":_vm.$t('webhook_secret'),"text-to-copy":_vm.secretCode}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }